import { Skeleton, Stack, Typography } from '@mui/material';
import { _ } from '/@/locale';
import FieldsByCropDashboardCard from '../../../components/dashboard-cards/fields-by-crop-dashboard-card';
import FieldsDashboardCard from '../../../components/dashboard-cards/fields-dashboard-card';

const FieldSection = ({ userNodeId }: { userNodeId: number | undefined }) => {
    return (
        <Stack spacing={3}>
            <Stack spacing={1}>
                <Typography color='primary' variant='h5'>
                    {_('Tu campaña actual')}
                </Typography>
                <Typography color='primary.mui.inactive' variant='body2'>
                    {_('Información clave de la campaña vigente.')}
                </Typography>
            </Stack>
            <Stack spacing={2}>
                {userNodeId ? (
                    <>
                        <FieldsDashboardCard userNodeId={userNodeId} showNewFieldButton={true} />
                        <FieldsByCropDashboardCard userNodeId={userNodeId} />
                    </>
                ) : (
                    <Skeleton variant='rectangular' height='500px' width='100%' />
                )}
            </Stack>
        </Stack>
    );
};

export default FieldSection;
